import request from '@/utils/request'

// 1. 热门证书列表
export function getHotCertificates(params) {
  return request({
    url: '/api/frontend/certificate-category/hot-list',
    method: 'get',
    params
  })
}

/**
 * 2. 证书类别列表
 * 获取所有认证类别，不分页，按排序返回
 * @returns {Promise}
 */
export function getCertificateCategories() {
  return request({
    url: '/api/frontend/certificate-category/list',
    method: 'get'
  })
}

// 3. 职业标准列表
export function getOccupationalStandards() {
  return request({
    url: '/api/frontend/certificate-category/occupational-standard-list',
    method: 'get'
  })
}

// 4. 违规通知列表
export function getViolationList(params) {
  return request({
    url: '/api/frontend/certificate-category/violation-list',
    method: 'get',
    params
  })
}

/**
 * 5. 证书查询接口
 * @param {Object} params
 * @param {string} [params.examNumber] - 准考证号（暂不使用）
 * @param {string} [params.idCard] - 身份证号
 * @param {string} [params.studentName] - 学生姓名
 * @returns {Promise}
 */
export function queryCertificates(data) {
  return request({
    url: '/api/frontend/certificate-category/certificate-query',
    method: 'get',
    params: data
  })
}
